import { ref } from 'vue'

const toggleOrSet = (valueRef, open) => {
  const doToggle = open === true || open === false
  return doToggle ? (valueRef.value = open) : (valueRef.value = !valueRef.value)
}

const showLeftNav = ref(false)
const toggleLeftNav = (open) => toggleOrSet(showLeftNav, open)
const openLeftNav = () => toggleOrSet(showLeftNav, true)
const closeLeftNav = () => toggleOrSet(showLeftNav, false)

const showSearchBar = ref(false)
const toggleSearchBar = (open) => toggleOrSet(showSearchBar, open)

export function useMenuToggles() {
  return {
    showLeftNav,
    toggleLeftNav,
    openLeftNav,
    closeLeftNav,
    //
    showSearchBar,
    toggleSearchBar,
  }
}
